export const SHOW_RESPONSE = 'SHOW_RESPONSE';
export const HIDE_RESPONSE = 'HIDE_RESPONSE';
